import {UI, registerStyle, styleRule, StyleSheet} from "../../../../../../../stem-core/src/ui/UI";

import {Messages} from "../../../../../../Messages";
import {SingleCard} from "./SingleCard";
import {ConfirmationModal} from "../../../../../../ui/ConfirmationModal";
import {LoadingSpinner} from "../../../../../../../core/ui/LoadingSpinner.jsx";
import {PopupMenu} from "../../../../../../ui/PopupMenu.jsx";
import {SubscriptionStore} from "../../../../../../../client/state/SubscriptionStore";
import {DonationStore} from "../../../../../../../client/state/DonationStore";
import {IrremovablePaymentMethodModal} from "./IrremovablePaymentMethodModal";
import {apiDeletePaymentMethod, apiSetPrimaryPaymentMethod} from "../../../../../../../client/state/PaymentMethodStore";
import {Toast} from "../../../../../../ui/Toast";
import {unwrapArray} from "../../../../../../../stem-core/src/base/Utils.js";


class SingleCardWidgetStyle extends StyleSheet {
    @styleRule
    container = {
        position: "relative",
        display: "flex",
        alignItems: "center",
        color: this.themeProps.PAYMENT_METHOD_COLOR
    };

    @styleRule
    cardDetails = {
        marginRight: 6,
    };
}

class RemoveCardModal extends ConfirmationModal {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            testId: "removeCardModal",
            title: Messages.removeCard,
            confirmLabel: Messages.remove,
            confirmAction: () => this.removeCard(),
            description: Messages.removeCardEndingIn(this.options.card.getBrand(), this.options.card.getLastDigits()),
        };
    }

    async removeCard() {
        LoadingSpinner.show();
        try {
            await apiDeletePaymentMethod(this.options.card.id);
            Toast.show(Messages.cardRemoved);
        } catch (error) {
            Toast.show(error.message);
        } finally {
            LoadingSpinner.hide();
            this.hide();
        }
    }
}

@registerStyle(SingleCardWidgetStyle)
export class SingleCardWidget extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            card: null,
        };
    }

    removeAction() {
        const {card} = this.options;
        const entries = [
            ...DonationStore.getActiveRecurring().filter(donation => !donation.isCanceled()),
            ...SubscriptionStore.getActiveAndNotCanceled()
        ].filter(recurringPayment => recurringPayment.getPaymentMethod() === card);

        if (entries.length) {
            IrremovablePaymentMethodModal.show({entries});
        } else {
            RemoveCardModal.show({card});
        }
    }

    async makeDefault() {
        await apiSetPrimaryPaymentMethod(this.options.card.id);
        Toast.show(Messages.changesSaved);
    }

    getMenuItems() {
        const {card} = this.options;

        return unwrapArray([{
                content: Messages.removeCard,
                onClick: () => this.removeAction(),
            },
            !card.isPrimary && {
                content: Messages.makeDefault,
                onClick: () => this.makeDefault(),
            }]);
    }

    render() {
        return [
            <SingleCard
                className={this.styleSheet.cardDetails}
                card={this.options.card}
                showPrimary={true}
            />,
            <PopupMenu items={this.getMenuItems()}/>
        ];
    }
}
